import * as React from "react";
import {Fragment, useEffect, useState} from "react";
import classNames from "classnames";
import {GrantMethod, MenuItemType} from "@commons/mapping/MenuItem";
import {useAppDispatch, useAppSelector} from "@hooks/redux-hooks/hooks";
import {alignMenu, toggleMenu} from "../core/menu/slice";
import {NavLink, useLocation} from "react-router-dom";
import {Transition} from "@headlessui/react";
import {selectProfiloAccessoAndPolicies} from "@commons/core.slice";
import {PoliciesFpnetDbRecordsPolicy, ProfiloAccessoAndPolicies} from "@commons/mapping/LoginResultRecord";
import {isArray} from "lodash";
import {
    IconAlertTriangle,
    IconArchive,
    IconBook,
    IconBuilding,
    IconCalendarClock,
    IconCalendarCog,
    IconCalendarMonth,
    IconCalendarSearch,
    IconCalendarUp,
    IconCalendarUser,
    IconChartDots3,
    IconChartPie,
    IconChevronUp,
    IconClock,
    IconCurrencyEuro,
    IconFileText,
    IconHome, IconMapDollar,
    IconUser,
    IconUsersGroup,
    IconWorld
} from "@tabler/icons-react";
import RectangleStackIcon from "../icons/RectangleStackIcon";
import InboxArrowDownIcon from "../icons/InboxArrowDownIcon";

const Icons = {
    IconBuilding: IconBuilding,
    IconChartDots3: IconChartDots3,
    IconCurrencyEuro: IconCurrencyEuro,
    IconWorld: IconWorld,
    IconHome: IconHome,
    IconUser: IconUser,
    IconArchive: IconArchive,
    IconChartPie: IconChartPie,
    IconBook: IconBook,
    IconUsersGroup: IconUsersGroup,
    IconFileText: IconFileText,
    IconClock: IconClock,
    IconCalendarMonth: IconCalendarMonth,
    IconCalendarClock: IconCalendarClock,
    IconCalendarUser: IconCalendarUser,
    IconCalendarSearch: IconCalendarSearch,
    IconCalendarUp: IconCalendarUp,
    IconCalendarCog: IconCalendarCog,
    IconMapDollar: IconMapDollar,
    RectangleStackIcon: RectangleStackIcon,
    InboxArrowDownIcon: InboxArrowDownIcon,
    // ArrowPathRoundedSquareIcon: ArrowPathRoundedSquareIcon,
};

type IconNameType = keyof typeof Icons

interface MenuIconProps {
    iconName: IconNameType,
    className?: string,
    current?: boolean,
}

const MenuIcon: React.FC<MenuIconProps> = ({iconName, className, current}) => {
    if (!className) {
        className =
            classNames(
                current ? 'text-gray-500' : 'text-gray-400 group-hover:text-gray-500',
                'mr-3 flex-shrink-0 h-6 w-6'
            );
    }
    if (typeof Icons[iconName] !== "undefined") {
        // TODO Rivedere il type
        return React.createElement<any>(Icons[iconName], {className, "aria-hidden": true});
    }
    return React.createElement<any>(IconAlertTriangle, {
            className: 'mr-3 flex-shrink-0 h-6 w-6 text-red-800',
            "aria-hidden": true
        }
    );
};

function isGranted(grant: string | string[], grantMethod: GrantMethod, profilo: ProfiloAccessoAndPolicies) {
    let granted = false;
    let grants: string[] = [];
    if (!isArray(grant)) {
        grants.push(grant);
    } else {
        grants = grant;
    }

    let almenoUnoGranted = false;
    for (const g of grants) {
        const policy: PoliciesFpnetDbRecordsPolicy | undefined = profilo.policies.find(p => p.uri === g);
        if (policy && policy[grantMethod])
            almenoUnoGranted = true;
    }
    granted = almenoUnoGranted;

    return granted;
}

interface MenuItemProps {
    siblingItems: MenuItemType[],
    index: number;
    text: string; // es. 'text-sm font-medium' oppure 'text-base font-medium'
    stato?: string; // es. 'text-sm font-medium' oppure 'text-base font-medium'
}

const MenuItem: React.FC<MenuItemProps> = ({siblingItems, index, text, stato = ''}) => {
    const location = useLocation();
    const profilo = useAppSelector(selectProfiloAccessoAndPolicies);

    const [count, setCount] = useState(0);
    const dispatch = useAppDispatch();

    const item = siblingItems[index];
    const grant = item.params ? item.params.grant || null : null;
    const grantMethod = item.params ? item.params.grantMethod || 'gGet' : 'gGet';
    const granted = (!grant || !profilo) || isGranted(grant, grantMethod, profilo);
    const subMenu = item.menu;
    const isShowing = item.menuIsOpen ? item.menuIsOpen : false;

    useEffect(() => {
        setCount((count) => count + 1);
    }, [item])

    function selVoce(stato: string) {
        //dispatch(activeMenuItem(stato))
        dispatch(alignMenu({newStato: stato, oldStato: location.pathname}))
    }

    function selMenu() {
        dispatch(toggleMenu({siblingItems, current: item}))
    }

    const newStato = stato + '/' + item.path;

    if (!granted) return <></>
    //console.log(stato,item.stato)
    return (
        <span key={count}>
            {/* Voce effettiva verso una pagina */}
            {!subMenu &&
                <NavLink
                    onClick={() => {
                        //selVoce(item.path)
                        selVoce(newStato)
                    }}
                    to={newStato}
                    className={({isActive}) => {
                        //console.log(newStato,'isActive:',isActive)
                        return classNames(item.current ? 'bg-gray-100 text-gray-900' : 'text-gray-600 hover:bg-gray-50 hover:text-gray-700',
                            'group flex items-center px-2 py-2 rounded-md', text
                        )
                    }}
                >
                    {item.icona && <MenuIcon iconName={item.icona as IconNameType} current={item.current}/>}
                    {item.descrizione}
                </NavLink>
            }

            {/* Voce di un sotto menu */}
            {subMenu && <>

                <button onClick={() => selMenu()}
                        className={classNames(isShowing ?
                                'bg-gray-100' :
                                'text-gray-600 hover:bg-gray-50 hover:text-gray-700',
                            'w-full group flex items-center px-2 py-2 font-medium rounded-md relative',
                            text
                        )}>
                    {item.icona && <MenuIcon iconName={item.icona as IconNameType} current={item.current}/>}
                    {/*{item.icona && <item.icona className={iconClassName} aria-hidden="true"/>}*/}
                    {item.descrizione}

                    <IconChevronUp className={`${isShowing ? 'rotate-180' : 'rotate-90'} absolute right-0 mr-2 h-5 w-5 text-blue-500 transform duration-300`}/>
                </button>

                <Transition
                    show={isShowing}
                    enter="transition-opacity duration-75"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="transition-opacity duration-150"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="pl-3">
                        <nav className="flex-1 space-y-1 pl-2 pb-4">
                            {subMenu.map((item, index) => (
                                <MenuItem key={index} index={index} text={text} siblingItems={subMenu} stato={newStato}></MenuItem>
                            ))}
                        </nav>
                    </div>
                </Transition>
            </>}
        </span>)
}
export default MenuItem;